<template lang="pug">
  div.c-wrap(v-if="pageData")
    h1.title-main {{pageData.title}}
    template(v-for="el in formElements")
      template(v-if="hasRowColumns")
        div.form-row(:class="{'is-multi-cols': el.length > 1}")
          template(v-for="col in el")
            component(
              :class="['form-row__item']"
              :key="col.question"
              :is="importedComponents[col.vueName]"
              :value="col.value"
              v-bind="{...col, 'style': el.length > 1 ? {width: `calc((100% / ${el.length}) - 1em)`}: null}")
      template(v-else)
        div.form-row
          component(
            :class="['form-row__item']"
            :style="[el.styles]"
            :key="el.question"
            :is="importedComponents[el.vueName]"
            :value="el.value"
            v-bind="{...el}")
</template>

<script>
  import buildControls from '../mixins/buildControl';
  import combineFormRows from '../mixins/combineFormRows';

  export default {
    name: 'Poll',
    mixins: [buildControls, combineFormRows],
    computed: {
      pageData () {
          return this.$store.state.polls.currentPoll;
      }
    },
    updated () {
      this.$store.commit('polls/updatePollComponent', this.$children);
    },
    watch: {
      pageData (val) {
        if (val) {
          this.buildControls(val.elements);
        }
      }
    }
  }
</script>
